import React from "react";
import { List, Typography, Card } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import qrCodeKioskDownload from 'images/qr-code-kiosk-download.svg';
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const ConnectionContent: React.FC = () => {
    const selectedKiosk = useSelector((state: RootState) => state.kiosks.selectedKiosk);
    const { t } = useTranslation();

    const data = [
        { label: t('kiosk.form.deviceType'), value: selectedKiosk?.deviceType || 'N/A' },
        { label: t('kiosk.form.osVersion'), value: selectedKiosk?.osVersion || 'N/A' },
        { label: t('kiosk.form.kioskVersion'), value: selectedKiosk?.kioskVersion || 'N/A' },
    ];

    return (
        <>
            {selectedKiosk?.status.id === 1 ? (
                <List
                    header={(t('kiosk.form.connectionTitle'))}
                    itemLayout="horizontal"
                    dataSource={data}
                    bordered
                    renderItem={item => (
                        <List.Item>
                            <List.Item.Meta
                                title={item.label}
                                description={item.value}
                            />
                        </List.Item>
                    )}
                />
            ) : (
                <Card title={t('kiosk.form.instructions')} style={{ margin: '20px' }}>
                    <ol>
                        <li>
                            {t('kiosk.form.step1')}
                            <div style={{ textAlign: 'center', margin: '20px 0' }}>
                                <div>{t('kiosk.form.downloadNote')}</div>
                                <img
                                    src={qrCodeKioskDownload}
                                    alt="QR Code to Download Avigilon Alta Visitor Kiosk App"
                                    style={{ width: '200px', height: '200px' }}
                                />
                            </div>
                        </li>
                        <li>
                            {t('kiosk.form.step2')}
                            <div style={{ textAlign: 'center', margin: '20px 0' }}>
                                <Text strong style={{ fontSize: '24px', color: '#89CFF0' }}>{selectedKiosk?.code || 'N/A'}</Text>
                            </div>
                        </li>
                    </ol>
                </Card>
            )}
        </>
    );
};

export default ConnectionContent;
